export const LIMIT = 10;

export const getHeight = (step) => {
   if (step === 1) {
      return "480px";
   } else if (step === 2 || step === 7) {
      return "311px";
   } else if (step === 3) {
      return "620px";
   } else if (step === 4) {
      return "560px";
   } else if (step === 5 || step === 8) {
      return "359px";
   } else if (step === 6 || step === 9) {
      return "513px";
   } else if (step === 6) {
      return "513px";
   }
};

export const getHeaderAndPara = (step) => {
   switch (step) {
      case 1:
         return { header: "Sign Up", para: "Quickly activate your account" };
      case 6:
      case 9:
         return {
            header: "Congrats, your account has been verified!",
            para: "Now you can access your notes from anywhere and we’ll keep them safe.",
         };
      case 5:
      case 8:
         return { header: "Verify", para: "" };
      default:
         return { header: "Sign Up", para: "" };
   }
};
